export const API_KEYS = {
    API_URL: createReplaceVariable('https://api.vouchedfor.co.uk'),
    GOOGLE_ANALYTICS_KEY: createReplaceVariable('UA-52740656-5'),
    GOOGLE_TAG_MANAGER_KEY: createReplaceVariable('GTM-MV6B5B'),
};

export function createReplaceVariable(variableName) {
    if (process.env.NODE_ENV === 'production') {
        return variableName;
    } else {
        return process.env[variableName];
    }
}
